module.exports = __webpack_public_path__ + "img/hms-belfast-installation-thumbnail.d629c223.jpg";